<template>
  <div class="container mt-1">
    <div class="jumbotron">
      <h1 class="display-4">Welcome to Crypquest!</h1>
      <p class="lead">Crypquest - Foolproof Ransom Payment Workflow</p>
      <hr class="my-4" />
      <p>In the current version, we aim to systematize the workflow of ransom payment request creation and updating the ransom payment requests as they progress through the payment process. We provide the ability to update MavenLink fields directly from CrypQuest..</p>
      <p>In the next version, we aim to add additional features to automate certain aspects of a ransom payment workflow like OFAC, Bitcoin service integration to validate the wallet etc.</p>
      <p>Crypquest is a contribution To Arete Labs Initiative from the R&D group.</p>
      <div class="mt-5 w-100 d-flex justify-content-center">
        <button
          class="btn font-weight-bold btn-lg btnLogin"
          @click="login"
        >Login With Your Arete Account</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  mounted() {
    const config = {
      auth: {
        clientId: process.env.VUE_APP_clientId,
        authority: process.env.VUE_APP_tenant,
        prompt: "select_account"
      },
      cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false
      }
    };
    this.uaa = new Msal.UserAgentApplication(config);
    this.$root.$emit("init");
  },
  props: {},
  methods: {
    acquireToken: function() {
      let that$ = this;
      const loginRequest = {
        scopes: process.env.VUE_APP_scopes.split(",")
      };
      that$.uaa
        .acquireTokenSilent(loginRequest)
        .then(function(tokenResponse) {
          var token = tokenResponse.accessToken;
          that$.$store.commit("login", token);
          that$.$router.push({ name: "dashboard-view" });
          that$.$store.commit("user", {
            user: tokenResponse.account
          });
        })
        .catch(function(error) {
          if (error.name === "InteractionRequiredAuthError") {
            return msalnstance
              .acquireTokenPopup(tokenRequest)
              .then(function(tokenResponse) {
                var token = tokenResponse.accessToken;
                that$.$store.commit("login", token);
                that$.$router.push({ name: "dashboard-view" });
                that$.$store.commit("user", {
                  user: tokenResponse.account
                });
                that$.$root.$emit("done");
              })
              .catch(err => {
                that$.$root.$emit("done");
                // handle error
              });
          } else {
            that$.$root.$emit("done");
          }
        });
    },
    login: function(oEvent) {
      var that = this;
      const loginRequest = {
        scopes: process.env.VUE_APP_scopes.split(",")
      };
      this.$root.$emit("progress");
      this.$store.commit("uaa", that.uaa);
      if (this.uaa.getAccount()) {
        this.acquireToken();
      } else {
        this.uaa
          .loginPopup(loginRequest)
          .then(response => {
            // handle response
            that.acquireToken();
          })
          .catch(err => {
            // handle error
            that.$root.$emit("done");
          });
      }
    }
  },
  data() {
    return {
      uaa: {}
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.btnLogin {
  width: 400px;
  height: 100px;
  background-color: $primary-color;
  color: white;
  &:hover {
    color: white !important;
  }
}
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>